module.exports = __webpack_public_path__ + "img/slide6.9ff4728a.jpg";